import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function money(symbol, amount) {
  const n = Number(amount);
  if (amount == null || amount === '' || Number.isNaN(n)) return `${symbol || ''} —`.trim();
  const dec = Number.isInteger(n) ? 0 : 2;
  return `${symbol || ''} ${n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec })}`.trim();
}
